import { render, staticRenderFns } from "./Npm.vue?vue&type=template&id=4db8998b&"
import script from "./Npm.vue?vue&type=script&lang=js&"
export * from "./Npm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db8998b')) {
      api.createRecord('4db8998b', component.options)
    } else {
      api.reload('4db8998b', component.options)
    }
    module.hot.accept("./Npm.vue?vue&type=template&id=4db8998b&", function () {
      api.rerender('4db8998b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Npm.vue"
export default component.exports